<template>
  <ClientOnly>
    <div class="relative w-full">
      <swiper
        class="w-full"
        loop
        :breakpoints="breakpoints"
        :modules="[Navigation]"
        :navigation="{
          nextEl: rightPaginationButton,
          prevEl: leftPaginationButton,
        }"
        @init="slideCallback"
        @resize="slideCallback"
      >
        <swiper-slide
          v-for="release in releases"
          :key="`swiper-slide-release-card-${release.id}`"
        >
          <ReleaseCard
            :release="release"
            :show-details="showDetails"
            :vertical="useVerticalCards"
            :show-site-rank="showSiteRank"
          />
        </swiper-slide>
      </swiper>

      <div
        class="absolute inset-0 w-full max-w-7xl mx-auto pointer-events-auto"
      >
        <div ref="leftPaginationButton" class="swiper-button-prev" />
        <div ref="rightPaginationButton" class="swiper-button-next" />
      </div>
    </div>
  </ClientOnly>
</template>

<script setup>
  import "swiper/css"
  import "swiper/css/navigation"

  import { Swiper, SwiperSlide } from "swiper/vue"
  import { Navigation } from "swiper/modules"

  defineOptions({
    name: "ReleaseSlider",
  })

  const props = defineProps({
    releases: {
      type: Array,
      required: true,
    },
    showDetails: {
      type: Boolean,
      default: true,
    },
    showSponsor: {
      type: Boolean,
      default: true,
    },
    showSiteRank: {
      type: Boolean,
      default: true,
    },
    breakpoints: {
      type: Object,
      default: () => ({
        320: {
          slidesPerGroup: 1,
          slidesPerView: 1,
          spaceBetween: 0,
        },
        480: {
          slidesPerGroup: 2,
          slidesPerView: 2,
          spaceBetween: 10,
        },
        640: {
          slidesPerGroup: 3,
          slidesPerView: 3,
          spaceBetween: 10,
        },
      }),
    },
    useVerticalCards: {
      type: Boolean,
      default: false,
    },
  })

  const leftPaginationButton = ref(null)
  const rightPaginationButton = ref(null)

  const { isMobile, isTablet, isDesktop } = useResponsive()

  const slideCallback = () => {
    if (isMobile.value && props.releases.length <= 1) {
      hidePaginationButtons()
    } else if (isTablet.value && props.releases.length <= 2) {
      hidePaginationButtons()
    } else if (isDesktop.value && props.releases.length <= 3) {
      hidePaginationButtons()
    } else {
      showPaginationButtons()
    }
  }

  const hidePaginationButtons = () => {
    leftPaginationButton.value.style.display = "none"
    rightPaginationButton.value.style.display = "none"
  }

  const showPaginationButtons = () => {
    leftPaginationButton.value.style.display = "block"
    rightPaginationButton.value.style.display = "block"
  }
</script>

<style lang="scss" scoped>
  .swiper-button-next,
  .swiper-button-prev {
    padding: 30px;
    position: absolute;
    z-index: 2;
    top: 36%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 100ms ease-in-out;
    color: white;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 100%;

    &:hover {
      transform-origin: center;
      transform: scale(1.25);
      background-color: rgba(255, 255, 255, 0.5);
      filter: drop-shadow(0 0 5px rgba(0, 0, 0, 1));
    }
  }

  .swiper-button-prev {
    background-image: url("/images/pagination-arrow-left.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    left: -1.7rem;
  }

  .swiper-button-next {
    background-image: url("/images/pagination-arrow-right.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    right: -1.7rem;
  }
</style>
